export const PrimaryColor = '#2C87F3';
